import { c as _c } from "react/compiler-runtime";
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
export interface BackButtonProps {
  url: string;
  label: string;
}
export const BackButton: React.FC<BackButtonProps> = t0 => {
  const $ = _c(4);
  const {
    url,
    label
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArkIcon iconName="chevron-left" size="1rem" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label || $[2] !== url) {
    t2 = <Link href={url} className="flex gap-snug-xl items-center label-md label-neutral-moderate pb-snug-xl no-underline">{t1}{label}</Link>;
    $[1] = label;
    $[2] = url;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};